import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { RouteLocationRaw } from "vue-router";
import { computed } from "vue";
import AppIcon from "@/components/app/AppIcon.vue";

interface Props {
  to: RouteLocationRaw,
  linkClass: string,
  wrapperClass?: string | false,
  icon?: string | false,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppRouterNavLink',
  props: {
    to: null,
    linkClass: null,
    wrapperClass: { type: [String, Boolean], default: false },
    icon: { type: [String, Boolean], default: false }
  },
  setup(__props: any) {

const props = __props as { to: RouteLocationRaw, linkClass: string, wrapperClass: string | false, icon: string | false };



const wrapperClasses = computed(() => {
  const result: { [key: string]: boolean } = {}

  if (props.wrapperClass) {
    result[props.wrapperClass] = true
  }

  return result
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(wrapperClasses))
  }, [
    _createVNode(_component_router_link, {
      "active-class": "active",
      class: _normalizeClass(__props.linkClass),
      to: props.to
    }, {
      default: _withCtx(() => [
        (props.icon)
          ? (_openBlock(), _createBlock(AppIcon, {
              key: 0,
              icon: props.icon,
              class: "route-nav-link-icon"
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "to"])
  ], 2))
}
}

})